import { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useSelector } from "react-redux";
import ProtectedRoute from "./ProtectedRoute";
import authRoute from "./route/auth";
import mainRoute from "./route/main";
import { RootState } from "store";
import { ScrollToTop } from "@components/common/ScrollToTop";
import GlobalSpin from "@components/spin";
import { AppShellFallback } from "@components/common/RouteLoadingFallback";
import AppLayout from "./layout/AppLayout";

const NotFound = lazy(() => import("@pages/OtherPage/NotFound"));
const BookingSharePage = lazy(() => import("@pages/Booking/Share"));

export default function App() {
  const loading = useSelector((state: RootState) => state.loading.isLoading);
  return (
    <>
      <Router basename="">
        <ScrollToTop />
        <Suspense fallback={<AppShellFallback />}>
          <Routes>
            <Route element={<ProtectedRoute />}>
              <Route element={<AppLayout />}>
                {mainRoute.map(({ path, component: Component }) => (
                  <Route key={path} path={path} element={<Component />} />
                ))}
              </Route>
            </Route>
            {authRoute.map(({ path, component: Component }) => (
              <Route key={path} path={path} element={<Component />} />
            ))}
            <Route path="/booking/:id" element={<BookingSharePage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </Router>
      {loading && <GlobalSpin />}
    </>
  );
}
